import { useApi } from "../Api";
import { FilterDef, HTTPGenericResponse } from "../../constants/FinanceModels";
import qs from "qs";
import { getFilterValue } from "../../utils/FilterUtils";
import {
    ID_FILTER_CUSTOMER,
    ID_FILTER_CUSTOMER_COMPANY_NAME,
    ID_FILTER_CUSTOMER_ID,
    ID_FILTER_INVOICEDATEFROM,
    ID_FILTER_INVOICEDATETO,
    ID_FILTER_SEARCH,
    ID_FILTER_STATUS,
    ID_FILTER_LEGAL_ENTITIES, ID_FILTER_DEALERS
} from "../../pages/payableinvoices/constants/PayableInvoicesFilters";
import dayjs from "dayjs";
import { useContext } from "react";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";

export const usePayableInvoicesRepository = () => {

    const {GET, DELETE} = useApi();
    const PATH = "/finance/invoice"

    const {  globalData: { user } } = useContext(GlobalContext);
    const allLegalEntities: any[] = user.legalEntities?.filter((x: any) => x.name.toLowerCase() !== "all").map((x: any) => x.name);
        

    function getPayableInvoices(offset: number, limit: number, sort: string | null, order: string | null, filterDefs: FilterDef[] = []): Promise<HTTPGenericResponse> {

        let search = getFilterValue(ID_FILTER_SEARCH, filterDefs);
        let customer = getFilterValue(ID_FILTER_CUSTOMER, filterDefs);
        let customerId = getFilterValue(ID_FILTER_CUSTOMER_ID, filterDefs);
        let customerCompanyName = getFilterValue(ID_FILTER_CUSTOMER_COMPANY_NAME, filterDefs);
        let statuses = getFilterValue(ID_FILTER_STATUS, filterDefs);
        let dateFrom: Date = getFilterValue(ID_FILTER_INVOICEDATEFROM, filterDefs);
        let dateTo: Date = getFilterValue(ID_FILTER_INVOICEDATETO, filterDefs);
        let legalEntities: string[] = getFilterValue(ID_FILTER_LEGAL_ENTITIES, filterDefs) || allLegalEntities;
        let dealers: string[] = getFilterValue(ID_FILTER_DEALERS, filterDefs);

        let params = {
            offset: offset,
            limit: limit,
            sort: sort,
            order: order,
            accountType: "PAYABLE",
            search: search,
            customer: customer,
            customerId: customerId,
            customerCompanyName: customerCompanyName,
            statuses: statuses,
            from: dateFrom ? dayjs(dateFrom).toISOString() : null,
            to: dateTo ? dayjs(dateTo).toISOString() : null,
            legalEntities,
            dealers
        }

        return GET(`${PATH}/all`, {
            params: params,
            paramsSerializer: (params) => qs.stringify(params, {arrayFormat: 'repeat', skipNulls: true})
        }, true);
    }

    function getPayableInvoiceById(id: string): Promise<HTTPGenericResponse> {
        return GET(`${PATH}/${id}`, {}, true);
    }


    function getSummary(filterDefs: FilterDef[] = []): Promise<HTTPGenericResponse> {
        let search = getFilterValue(ID_FILTER_SEARCH, filterDefs);
        let customer = getFilterValue(ID_FILTER_CUSTOMER, filterDefs);
        let customerId = getFilterValue(ID_FILTER_CUSTOMER_ID, filterDefs);
        let customerCompanyName = getFilterValue(ID_FILTER_CUSTOMER_COMPANY_NAME, filterDefs);
        let statuses = getFilterValue(ID_FILTER_STATUS, filterDefs);
        let dateFrom: Date = getFilterValue(ID_FILTER_INVOICEDATEFROM, filterDefs);
        let dateTo: Date = getFilterValue(ID_FILTER_INVOICEDATETO, filterDefs);
        let legalEntities: string[] = getFilterValue(ID_FILTER_LEGAL_ENTITIES, filterDefs) || allLegalEntities;
        let dealers: string[] = getFilterValue(ID_FILTER_DEALERS, filterDefs);


        let params = {
            search: search,
            customer: customer,
            customerId: customerId,
            customerCompanyName: customerCompanyName,
            statuses: statuses,
            from: dateFrom ? dayjs(dateFrom).toISOString() : null,
            to: dateTo ? dayjs(dateTo).toISOString() : null,
            accountType: "PAYABLE",
            legalEntities,
            dealers
        }

        return GET(`${PATH}/all-types-summary`, {
            params,
            paramsSerializer: (params) => qs.stringify(params, {arrayFormat: 'repeat', skipNulls: true})
        });
    }


    function deleteInvoice(id: string): Promise<HTTPGenericResponse> {
        return DELETE(`${PATH}/${id}`, {}, true);
    }

    function downloadPDF(id: string) {
        return GET(`${PATH}/pdf/${id}`);
    }

    function downloadXML(id: string) {
        return GET(`${PATH}/xml/${id}`);
    }

    function getMockMandatary() {
        return {
            mandataryCode: "210730",
            mandataryCompany: "D.B. AUTOMOTIVE SRL",
            mandataryAddress: "VIA JUNIPERO SERRA 19",
            mandataryCity: "Bari",
            mandataryZip: "70125",
            mandataryCountry : "IT",
            mandataryProvince: "(BA)",
            mandataryTaxCode: "07324000723",
            mandataryVatNumber: "07324000723"
        }
    }


    return {getPayableInvoices, getPayableInvoiceById, getSummary, deleteInvoice, downloadPDF, getMockMandatary, downloadXML}
}